import React from 'react';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './Page.module.css';

const CadSkill = () => {
    return (
        <div className='Page CadSkill'>
            <Banner title={`CAD & FEA`} custom={true} />
            <section className={styles.section}>

            </section>
            <Footer></Footer>
        </div>
    );
};

export default CadSkill;